const numberOfBuckets = 20;

class IntervalsHandler {
  duration = 0;
  intervalBuckets = [];
  previousIntervalBucketsData = [];
  sendFn;

  registerServerHandler(fn) {
    this.sendFn = fn;
  }

  /**
   * Create 5% buckets based on video duration
   * @param {number} duration - the video duration
   */
  createBucketsForLength(duration) {
    // Android might set duration as Infinite in certain cases
    if (!this.isValidDuration(duration) || this.intervalBuckets.length) {
      return;
    }

    this.duration = duration;

    const bucketSize = duration / numberOfBuckets;

    for (let i = 0; i < numberOfBuckets; i++) {
      this.intervalBuckets.push({
        start: bucketSize * i,
        end: bucketSize * (i + 1),
      });
    }

    // ensure that the last bucket goes to the end, to avoid rounding problems
    this.intervalBuckets[numberOfBuckets - 1].end = duration;
  }

  /**
   * Get the bucket index at the given time
   * @param {number} time - the time in the video to find the bucket for
   */
  getBucketIndex(time) {
    return this.intervalBuckets.findIndex(
      bucket => bucket.start <= time && bucket.end >= time
    );
  }

  /**
   * Check if the current video time falls into a bucket
   * and save it if not already filled.
   * @param {number} previousTime - previousTime video time, i.e. the last
   *        time that was used the previous time this function was called
   * @param {number} time - current video time
   */
  fillBucketAtTimestamp(previousTime, time) {
    const previousBucketIndex = this.getBucketIndex(previousTime);
    const bucketIndex = this.getBucketIndex(time);

    if (
      previousBucketIndex < 0 ||
      bucketIndex < 0 ||
      previousBucketIndex > bucketIndex
    ) {
      return;
    }

    for (let i = previousBucketIndex; i <= bucketIndex; i++) {
      this.intervalBuckets[i].filled = true;
    }
  }

  getBucketsAsArray() {
    return this.intervalBuckets.map(bucket => Boolean(bucket.filled));
  }

  /**
   * Syncs the buckets with the server.
   * After each call we'll get the most up to date representation of the buckets
   * and we're ferry that to the internal state.
   */
  async syncBuckets() {
    const currentData = this.getBucketsAsArray();
    const hasSomethingChanged =
      // first time we're syncing in this session ...
      !this.previousIntervalBucketsData.length ||
      // ... or one of the buckets has changed
      currentData.find(
        (currentValue, index) =>
          currentValue !== this.previousIntervalBucketsData[index]
      );

    if (!hasSomethingChanged) {
      return;
    }

    try {
      const data = await this.sendFn(this.getBucketsAsArray());

      if (!data) {
        return;
      }

      const buckets = data.buckets;

      buckets.forEach((value, bucketIndex) => {
        this.previousIntervalBucketsData[bucketIndex] = Boolean(value);
        this.intervalBuckets[bucketIndex].filled = Boolean(value);
      });
    } catch (err) {
      console.error(err);
    }
  }

  isValidDuration(duration) {
    return duration && isFinite(duration);
  }
}

export default IntervalsHandler;
